/**
 * Dependency-free city matching shared by the browser pages and the Vercel
 * functions, so the client, /api/displays/location and api/seo-render all
 * decide "is this row in that city" the same way.
 */

/** Slugify a place name for browse URLs: "Fort Worth" -> "fort-worth". */
export const toGeoSlug = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

/** The only city slug grammar the app emits; guards the ILIKE pattern below. */
export const SAFE_CITY_SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/**
 * Loose SQL ILIKE prefilter for a city slug ("st-louis" -> "%st%louis%"). It
 * over-matches on purpose (punctuation, stray whitespace); callers must then
 * keep only rows where matchesCitySlug() is true.
 */
export const cityIlikePattern = (citySlug: string): string => `%${citySlug.split('-').join('%')}%`;

export const matchesCitySlug = (city: string | null | undefined, citySlug: string): boolean =>
  Boolean(city) && toGeoSlug(city as string) === citySlug;
